import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import RadioButton from 'app/components/shared/RadioButton';

import Capsule from 'app/components/shared/Capsule';

import './SelectionCard.scss';

export function SelectionCard(props) {
  const { label, name, selected, value } = props;
  const contentClassNames = cn('selection-card__content', {
    'selection-card__content--selected': selected
  });

  function handleClick() {
    if (props.handleClick) props.handleClick(value);
  }

  return (
    <Capsule
      {...props}
      className="cp-selection-card"
      handleClick={handleClick}
      role="radio"
      active={selected}
      contentClassName={contentClassNames}
    >
      <RadioButton id={value} label={label} name={name} checked={selected} />
    </Capsule>
  );
}

SelectionCard.defaultProps = {
  selected: false
};

SelectionCard.propTypes = {
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  name: PropTypes.string,
  selected: PropTypes.bool,
  handleClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default SelectionCard;
